/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum ContextLevel {
    NONE = 0,
    NETWORK = 1,
    PROJECT = 2,
    SUB_PROJECT = 3
}
